// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// Material Design Icons
import 'material-design-icons/iconfont/material-icons.css'
// Material Design Fonts (@mdi/font)
import '@mdi/font/css/materialdesignicons.min.css'
// Roboto font face
import 'roboto-fontface/css/roboto/roboto-fontface.css'

import Vue from 'vue'
import App from './App'

import store from './store'

import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

import Loading from '@/components/Loading'
Vue.use(Loading)

//Helpers
import dmsHelpers from '@/helpers'
Vue.use(dmsHelpers)

Vue.prototype.$store = store
Vue.config.productionTip = false

import Editor from '@tinymce/tinymce-vue';
Vue.component('dantser-editor', Editor);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js